import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#9CE2E2",
  d: "M84 80l30-17v34z"
}), React.createElement("path", {
  fill: "#5EBCBA",
  d: "M114 97l-30 17V80z"
}), React.createElement("path", {
  fill: "#37AFB5",
  d: "M84 114l30-17v34z"
}), React.createElement("path", {
  fill: "#9CE2E2",
  d: "M114 131l-30 17v-34z"
}), React.createElement("path", {
  fill: "#0CC6C6",
  d: "M84 148l30-17v34z"
}), React.createElement("path", {
  fill: "#036F8C",
  d: "M114 165l-30 17v-34z"
}), React.createElement("path", {
  fill: "#18A5A8",
  d: "M72 45L42 62V28z"
}), React.createElement("path", {
  fill: "#2AB2BC",
  d: "M42 62l30-17v34z"
}), React.createElement("path", {
  fill: "#036F8C",
  d: "M72 79L42 96V62z"
}), React.createElement("path", {
  fill: "#0CC6C6",
  d: "M42 96l30-17v34z"
}), React.createElement("path", {
  fill: "#9CE2E2",
  d: "M72 113l-30 17V96z"
}), React.createElement("path", {
  fill: "#37AFB5",
  d: "M42 130l30-17v34z"
}), React.createElement("path", {
  fill: "#5EBCBA",
  d: "M72 147l-30 17v-34z"
}), React.createElement("path", {
  fill: "#9CE2E2",
  d: "M42 164l30-17v34z"
}), React.createElement("g", null, React.createElement("path", {
  fill: "#9CE2E2",
  d: "M0 79l30-17v34z"
}), React.createElement("path", {
  fill: "#5EBCBA",
  d: "M30 96L0 113V79z"
}), React.createElement("path", {
  fill: "#37AFB5",
  d: "M0 113l30-17v34z"
}), React.createElement("path", {
  fill: "#9CE2E2",
  d: "M30 130L0 147v-34z"
})), React.createElement("g", {
  fill: "#036F8C"
}, React.createElement("path", {
  d: "M71 23.505c3.404 7.148 2.049 14.904 2.049 14.904s-6.877-3.835-10.28-10.983c-3.405-7.15-2.05-14.904-2.05-14.904s6.877 3.835 10.282 10.983m24.649-.295c-7.506 9.955-19.323 13.703-19.323 13.703s.353-12.393 7.86-22.348C91.693 4.611 103.51.863 103.51.863s-.353 12.392-7.86 22.347M11.013 146.301c5.175-3.364 11.307-3.112 11.307-3.112s-2.258 5.707-7.433 9.071-11.307 3.112-11.307 3.112 2.258-5.707 7.433-9.07M22.61 161.15c-1.275-9.635 3.24-18.18 3.24-18.18s6.58 7.077 7.855 16.712c1.275 9.635-3.239 18.179-3.239 18.179s-6.58-7.076-7.856-16.711"
})));

var SvgLogo = function SvgLogo(props) {
  return React.createElement("svg", props, _ref);
};

export default "data:image/svg+xml;base64,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";
export { SvgLogo as ReactComponent };